import { RQ_KEY } from '@constants/api';
import {
  QueryCommonOptions,
  useQueryWithCallbacks,
} from '@hooks/useQueryWithCallbacks';
import { orderStatusServiceFactory } from '@lib/apiFactory';

const { orderStatusServiceOrderStatusGetV1 } = orderStatusServiceFactory;

type AvailableOrderStatusServiceParams = {
  restaurantId: string;
  orderId: string;
};

export const useOrderStatusService = () => {
  const useOrderStatusServiceOrderStatusGetV1 = ({
    restaurantId,
    orderId,
    options,
    useQueryOptions,
    onSuccess,
    onError,
  }: AvailableOrderStatusServiceParams &
    QueryCommonOptions<typeof orderStatusServiceOrderStatusGetV1>) => {
    const key = RQ_KEY.orderStatusServiceOrderStatusGetV1(
      restaurantId,
      orderId,
    );

    return useQueryWithCallbacks({
      queryKey: key,
      queryFn: () =>
        orderStatusServiceOrderStatusGetV1(restaurantId, orderId, options),
      ...useQueryOptions,
      onSuccess,
      onError,
    });
  };

  return {
    useOrderStatusServiceOrderStatusGetV1,
  };
};
